export const checkIsOpenForm = (state) => state.purchaseForm.isOpen;
  
export const getPurchaseValues = (state) => state.purchaseForm.purchaseValues;